import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExgModalService, ExgTableComponent, ExgTableSettingsComponent} from 'exc-controls-v2';
import {ExcRestService, IExcDataDistinct, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';

@Component({
  selector: 'app-modal-choose-oe',
  templateUrl: './modal-choose-oe.component.html',
  styles: [
  ]
})
export class ModalChooseOEComponent extends ExcTranslation implements OnInit {
  @ViewChild('oeTable', {read: ExgTableComponent}) oeTable!: ExgTableComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;

  @Input() data = {
    oe_CrmRolle: 0,
    oe_enmIdent_OETyp: 0,
    isWAnspr: false,
    selectedWAnsprEnmIdent: -1,
    parentOEID: '00000000-0000-0000-0000-000000000000',
    MetaInfo: {
      dataFilter: {} as IExcDataFilter,
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort
    } as IExcMetaInfo
  };
  _data: any = [];
  init = true;

  oeList = {
    data: [] as any,
    MetaInfo: {
      dataFilter: {} as IExcDataFilter,
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    groups:  [] as any,
    distinctData: [],
    tableDef: [{caption: 'Typ', value: 'OeTyp', fixed: false, align: 0, sort: 0, visible: true},
      {caption: 'Rolle', value: 'CrmRolle', fixed: false, align: 0, sort: 0, visible: true},
      {caption: 'Name', value: 'AnzeigeName', fixed: false, align: 0, sort: 0, visible: true},
      {caption: 'Kurzbezeichnung', value: 'oeNPraefix', fixed: false, align: 0, sort: 0, visible: true},
      {caption: 'Ort', value: 'adrOrt', fixed: false, align: 0, sort: 0, visible: true},
      {caption: 'Land', value: 'adrLkz', fixed: false, align: 0, sort: 0, visible: true},
      {caption: 'Bezeichnung', value: 'adrBez', fixed: false, align: 0, sort: 0, visible: true}
    ]
  };
  wAnsprSelect = {
    data: [] as any
  };

  // config
  config = {
    oeList: {
      selectKey: 'oeID',
      state: 1,
      selectedRow: undefined as any,
      searchValue: '',
      uiFilter: [] as any[],
      uiSort: [] as any[],
      ready: () => {
        if (!this.oeList.data || this.oeList.data.length === 0) {
          this.config.oeList.state = 2;
          this.oeTable.selectedRow = -1;
        } else {
          this.config.oeList.state = 0;
          this.oeTable.selectedRow = 0;
        }
        this.init = false;
      },
      selectionChanged: (index: number) => {
        this.config.oeList.selectedRow = this.oeList.data[index];
      },
      pageChanged: (page: number) => {
        if (this.oeList.MetaInfo.dataPaging !== undefined) {
          this.oeList.MetaInfo.dataPaging.pageNo = page;
        }
        this.config.oeList.loadData();
      },
      search: (value: string) => {
        this.config.oeList.searchValue = value;
        this.config.oeList.pageChanged(1);
      },
      loadData: () => {
        const SELF = this;
        SELF.config.oeList.state = 1;
        const url = 'OER_List_CrmRolle_Parent_OETyp';
        SELF.excRestService
          .sget(
            SELF.excRestService.computeUrl(url, {
              oe_CrmRolle: this.data.oe_CrmRolle,
              oe_enmIdent_OETyp: this.data.oe_enmIdent_OETyp,
              parentOEID: this.data.parentOEID,
              fts: this.config?.oeList?.searchValue,
            }),
            'oeList',
            {
              MetaInfo: {
                dataPaging: this.oeList.MetaInfo.dataPaging,
                dataSort: this.oeList.MetaInfo.dataSort,
                dataFilter: this.oeList.MetaInfo.dataFilter
              }
            }
          )
          .subscribe((response) => {
            if (response.success && response.data) {
              SELF.oeList.data = response.data;
              SELF.oeList.paging = response.paging;
            } else {
              SELF.oeList.data = [];
              SELF.oeList.paging = {
                pagingPage: 0,
                pagingEndRow: 0,
                pagingPageSize: 25,
                pagingTotalPages: 0,
                pagingTotalRows: 0,
                pagingStartRow: 0,
              };
            }
            SELF.config.oeList.ready();
          });
      }
    }
  , wAnsprSelect: {
      isInit: true,
      showSelect: false,
      selectedIndex: 0,
      selectedEnmIdent: 0,
      selectionChanged: (index: number) => {
        this.config.wAnsprSelect.selectedIndex = index;
        this.config.wAnsprSelect.selectedEnmIdent = this.wAnsprSelect.data[index].enmIdent;
      },
      loadData: () => {
        this.wAnsprSelect.data = this.enumSvc.getEnumerationList('WAnsprPtnrFunktion');
        if (this.config.wAnsprSelect.isInit && this.data.selectedWAnsprEnmIdent >= 0) {
          const indexOfInsertedEnum = this.wAnsprSelect.data.map((a: any) => (a.enmIdent)).indexOf(this.data.selectedWAnsprEnmIdent);
          this.config.wAnsprSelect.selectionChanged(indexOfInsertedEnum);
          this.config.wAnsprSelect.isInit = false;
        }
        if (this.wAnsprSelect.data.length > 0 && this.data.isWAnspr) { this.config.wAnsprSelect.showSelect = true; }
      }
    }
  };

  constructor(public excRestService: ExcRestService, public modal: ExgModalService, public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    this.config.oeList.loadData();
    this.config.wAnsprSelect.loadData();
  }

  clickedSave(): void {
    const SELF = this;
    const returnObject = {
      chosenOE: this.config.oeList.selectedRow,
      chosenWAnsprEnmIdent: this.config.wAnsprSelect.selectedEnmIdent
    };
    this.modal.action(returnObject);
    SELF.modal.close();
  }

  clickedCancel(): void {
    const SELF = this;
    SELF.modal.close();
  }

  getDistinctOE(dataDistinct: IExcDataDistinct): void {
    this.oeList.MetaInfo.dataDistinct = dataDistinct;
    const url = this.excRestService.computeUrl('OER_List_CrmRolle_Parent_OETyp');
    this.excRestService
      .sget(
        this.excRestService.computeUrl(url, {
          oe_CrmRolle: this.data.oe_CrmRolle,
          oe_enmIdent_OETyp: this.data.oe_enmIdent_OETyp,
          parentOEID: this.data.parentOEID,
          fts: this.config?.oeList?.searchValue,
        }),
        'oeList',
        {
          MetaInfo: this.oeList.MetaInfo}).subscribe((response) => {
      this.oeList.distinctData = response.data;
    });
  }

  openTableSettings($event: any): void {
    this.VCtableDefinitionSettings.openFilterConfig($event);
  }
}
